








































/** @format */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class LangCar extends Vue {
  /**
   * 无限制： 9999
   */
  readonly infinityDay = 9999;

  @Prop(Number) monthRetentionPeriod?: number;
  @Prop(Boolean) disabled!: boolean;

  @Watch('monthRetentionPeriod')
  changePeriod(val) {
    if (this.infinityDay === val) return;
    this.inputNumberValue = val;
  }

  private inputNumberValue;

  get getMonthRetentionPeriod() {
    if (typeof this.monthRetentionPeriod === 'number') return this.monthRetentionPeriod;
    return this.infinityDay;
  }
  /**
   * input-number 现隐
   */
  get isDisabledInput(): boolean {
    if (this.disabled) return true;
    return this.monthRetentionPeriod === this.infinityDay;
  }
  /**
   * inputNumber chang事件
   */
  onChange(value) {
    if (typeof value !== 'number' || value < 0) {
      return;
    }
    this.$emit('change', value);
  }
  /**
   * radioGroup chang事件
   */
  onChangeRadio(e) {
    const value = e.target.value;
    if (typeof value !== 'number' || value < 0) {
      return;
    }
    this.$emit('change', value);
  }
}
